<script>
export default {
    name: 'ContentReferencesBlock',
    props: {
        data: Object,
    },
};
</script>

<template>
    <div class="references-block">
        <h2 class="references-block__title" v-if="data.title">{{ data.title }}</h2>
        <div 
            class="references-block__reference" 
            v-for="(reference, i) in data.reference" 
            v-bind:key="i" 
            v-bind:class="{'references-block__reference--with-caption': reference.caption}">
                <h3 class="references-block__reference__caption" v-if="reference.caption">{{ reference.caption }}</h3>
                <p class="references-block__reference__author">{{ reference.author }}</p>
                <p class="references-block__reference__title">{{ reference.title }}</p>
                <p class="references-block__reference__meta" v-if="reference.meta">{{ reference.meta }}</p>
                <a 
                    v-bind:href="reference.link.url" 
                    class="references-block__reference__link read-more" 
                    v-bind:target="reference.link.target" 
                    v-if="reference.link">{{ reference.link.caption || 'mehr erfahren' }}
                </a>
        </div>
    </div>
</template>

<style lang="scss" scoped>
$shifted-row-width: 10.08rem;

.references-block {
    margin: 12rem 0 12rem $shifted-row-width;

    @include breakpoint('sm-down') {
        margin-left: 0;
    }
}
.references-block__title {
    margin: 0 0 4.4rem -10.08rem;
    font-weight: 700;
    font-size: 3.2rem;

    @include breakpoint('sm-down') {
        margin-left: 0;
    }
}
.references-block__reference {
    position: relative;
    box-sizing: border-box;
    min-height: 11.6rem;
    padding: 0.96rem 0 4.096rem;
    border-top: 0.1rem solid rgba($color-primary, .15);
}
.references-block__reference:last-child {
    border-bottom: 0.1rem solid rgba($color-primary, .15);
}
.references-block__reference--with-caption {
    @include breakpoint('sm-down') {
        margin-top: 6.4rem;
    }
}
.references-block__reference__caption {
    position: absolute;
    left: 0; top: 0;
    margin: 1.1rem 0 0 $shifted-row-width * -1;
    font-size: 1.4rem;
    color: $color-secondary-alt;
    letter-spacing: 0.04rem;
    text-transform: uppercase;

    @include breakpoint('sm-down') {
        position: relative;
        margin: -3.7rem 0 2.1rem 0;
    }
}
.references-block__reference__author {
    margin: 0 0 0.8rem;
    font-size: 2rem;
    color: $color-secondary;
    letter-spacing: 0.057rem;
    line-height: 1.1;
}
.references-block__reference__title {
    margin: 0 0 1.2rem;
    font-size: 2rem;
    color: $color-primary;
    letter-spacing: 0.057rem;
    line-height: 1.35;
}
.references-block__reference__meta {
    margin: 0 0 2rem;
    font-size: 1.6rem;
    color: $color-primary;
    letter-spacing: 0.057rem;
    line-height: 1.25;
}
</style>
